<template>
  <div v-if="question != null && Object.keys(question).length > 0">
    <div v-if="question.type == 'surveySelect'">
      <div v-for="(option, key) in question.options" :key="key">
        <b-field label="" />
        <p class="">
          <b>
            {{ option.text }}
            <span v-if="serverAnswer != null && Object.keys(serverAnswer).length > 0">
              <span v-if="serverAnswer.answer[key]">
                <b-icon icon="check" size="is-small" />
              </span>
            </span>
          </b>
        </p>
        <b-field v-if="responses">
          <b-progress
            type="is-info"
            :size="presentation ? 'is-large' : 'is-medium'"
            show-value
            :value="(responses[key] / responses.total) * 100"
          >
            <span class="has-text-black">
              {{ Math.floor((responses[key] / responses.total) * 100) }}
            </span>
          </b-progress>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SurveyResults",
  components: {},
  props: {
    question: {
      type: Object,
      default() {
        return {};
      },
    },
    responses: {
      type: Object,
      default() {
        return {};
      },
    },
    serverAnswer: {
      type: Object,
      default() {
        return {};
      },
    },
    presentation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      isDisabled: false,
    };
  },
  computed: {},
  watch: {
    // PieChart code
    /*let question = survey.question
      let options = survey.options

      let labels = []
      let data = []
      for (let [key, value] of Object.entries(options)) {
        labels.push(value.question)
        data.push(survey[key])
      }
      
      this.data = {
        labels, datasets: [{
          label: question,
          data: data,
          backgroundColor: ["#3366cc","#dc3912","#ff9900","#109618","#990099","#0099c6","#dd4477","#66aa00","#b82e2e","#316395","#994499","#22aa99","#aaaa11","#6633cc","#e67300","#8b0707","#651067","#329262","#5574a6","#3b3eac","#b77322","#16d620","#b91383","#f4359e","#9c5935","#a9c413","#2a778d","#668d1c","#bea413","#0c5922","#743411"],
        }]
      }*/
  },
};
</script>

<style></style>
